// import Metismenu from "metismenujs";
import React, { useReducer, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import { Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MenuList } from "./Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { getAdminCredentials, getAdminById } from "../../../Api/AdminApi";

export function filtrarMenuPorPermisos(menuList, permisosUsuario) {
  return menuList
    .map((menu) => {
      // If menu has submenu
      if (menu.content) {
        // Filter submenus based on permissions
        const submenus = menu.content.filter((item) =>
          permisosUsuario.includes(item.permiso)
        );
        // If there are permitted submenus or the main menu has no permiso or is permitted, return the menu
        if (submenus.length && (!menu.permiso || permisosUsuario.includes(menu.permiso))) {
          return { ...menu, content: submenus };
        }
        // If no submenus are permitted, return null
        return null;
      } else {
        // Menu without submenu: check direct permission
        if (!menu.permiso || permisosUsuario.includes(menu.permiso)) {
          return menu;
        }
        return null;
      }
    })
    .filter(Boolean);
}

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  // Initialize permisosUsuario as an empty array
  
  const [permisosUsuario, setPermisosUsuario] = useState([]);
  const {
    iconHover,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  // Function to normalize and extract permissions from user data
  const extractPermissions = (userData) => {
    if (!userData) return [];
    // Map user permission keys to MenuList permiso format
    const permissionMap = {
      ventas_clientes: "ventas.clientes",
      ventas_facturas: "ventas.facturas",
      ventas_detalles: "ventas.detalles",
      ventas_reportes: "ventas.reportes",
      ventas_facturascontado: "ventas.facturascontado", // Assuming both subitems are tied to this permission
      ventas_facturascredito: "ventas.facturascredito", // Assuming both subitems are tied to this permission
      compras_proveedores: "compras.proveedores",
      compras_compras: "compras.compras",
      compras_listacompras: "compras.listacompra",
      compras_reportes: "compras.reporte",

      opciones_timbrado: "opciones.timbrado",
      opciones_sucursal: "opciones.sucursal",
      opciones_puntosdeventa: "opciones.puntosdeventa",
      opciones_formasdepago: "opciones.formadepago",
      opciones_servicioproducto: "opciones.servicioproducto",
      opciones_seguros: "opciones.seguros",
    };

    // Filter keys where value is "true" and map to MenuList permiso format
    const permissions = Object.keys(userData)
      .filter(
        (key) =>
          (key.startsWith("compras_") ||
            key.startsWith("ventas_") ||
            key.startsWith("opciones_")) &&
          userData[key] === "true" &&
          permissionMap[key]
      )
      .map((key) => permissionMap[key]);

   // Add "Admin" permission if IdTipoUsuario is not "0" or "1"
   if (userData.IdTipoUsuario && userData.IdTipoUsuario === "0" || userData.IdTipoUsuario === "1") {
     permissions.push("Admin");
   }
    return permissions;
  };

  const assignValue = async () => {
    try {
      const resultUser = await getAdminCredentials();
      const datauser = await getAdminById(resultUser.IdUsuario);
      if (datauser && datauser[0]) {
        const permissions = extractPermissions(datauser[0]);
        setPermisosUsuario(permissions);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setPermisosUsuario([]); // Set empty array on error to avoid breaking the filter
    }
  };

   useEffect(() => {
    assignValue();
 }, []);

   let handleheartBlast = document.querySelector('.heart');
   function heartBlast(){
     return handleheartBlast.classList.toggle("heart-blast");
   }


  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  // Path for active menu highlighting
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  // Filter menu based on user permissions
  const menuFiltrado = filtrarMenuPorPermisos(MenuList, permisosUsuario);

  return (
    <div
    
      className={`dlabnav   fixed horizotal static`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {menuFiltrado.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
             
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={` ${
                    state.active === data.title ? "mm-active" : ""
                  }`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => handleMenuActive(data.title)}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                        {data.update && (
                          <span className="ms-1 badge badge-xs style-1 badge-danger">
                            {data.update}
                          </span>
                        )}
                      </Link>
                      <Collapse in={state.active === data.title}>
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          {data.content.map((submenu, subIndex) => (
                            <li
                              key={subIndex}
                              className={`${
                                state.activeSubmenu === submenu.title
                                  ? "mm-active"
                                  : ""
                              }`}
                            >
                              {submenu.content && submenu.content.length > 0 ? (
                                <>
                                  <Link
                                    to={submenu.to}
                                    className={submenu.hasMenu ? "has-arrow" : ""}
                                    onClick={() =>
                                      handleSubmenuActive(submenu.title)
                                    }
                                  >
                                    {submenu.title}
                                  </Link>
                                  <Collapse
                                    in={state.activeSubmenu === submenu.title}
                                  >
                                    <ul
                                      className={`${
                                        menuClass === "mm-collapse"
                                          ? "mm-show"
                                          : ""
                                      }`}
                                    >
                                      {submenu.content.map(
                                        (subSubmenu, subSubIndex) => (
                                          <li key={subSubIndex}>
                                            <Link
                                              className={`${
                                                path === subSubmenu.to
                                                  ? "mm-active"
                                                  : ""
                                              }`}
                                              to={subSubmenu.to}
                                            >
                                              {subSubmenu.title}
                                            </Link>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : (
                                <Link to={submenu.to}>{submenu.title}</Link>
                              )}
                            </li>
                          ))}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link to={data.to}>
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;